import React from 'react'
import { useHistory } from "react-router-dom";
import TractorSlider from './TractorSlider'
import { Tabs, Button } from 'antd'


const { TabPane } = Tabs


function TractorSection() {
    const history = useHistory();

    const viewAll = <Button 
                        type="primary" 
                        onClick={() => history.push('/upcoming-tractors')}>
                            View All
                        </Button>;

    return (
        <div className="mt-1">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <h2 className="text-2xl font-bold text-gray-700">Tractors</h2>
                    
                    <Tabs defaultActiveKey="1" tabBarExtraContent={viewAll}>
                        <TabPane tab="Popular" key="1">
                            <TractorSlider category="POPULAR" />
                        </TabPane>

                        <TabPane tab="Latest" key="2">
                            <TractorSlider  category="LATEST" />
                        </TabPane>

                        <TabPane tab="Upcoming" key="3">
                            <TractorSlider  category="UPCOMING" />
                        </TabPane>
                    </Tabs>
                    
                </div>
            </div>
            
        </div>
    );
}

export default TractorSection;
